// extracted by mini-css-extract-plugin
export default {"circle":"oAU15YJklhAp53_","size-xsmall":"s3SzhsBfd6Qoc3v","size-small":"P1QJFLtSmNHWPUh","size-medium":"cGagd6GTRwulWQP","size-large":"NdmrpZgz7jMUjov"};